const backendUrl = 'https://portfolio-backend-0kgn.onrender.com';

export default backendUrl;